<route>
{
    "name": "employee-holiday-planner",
    "meta": {
        "title": "Planificare concedii",
        "requiresAuth": true,
        "permission": "guest",
        "fail": "/404"
    }
}
</route>
<template>
    <company-layout>
        <v-container fluid grid-list-xl>
            <v-row>
                <v-col>
                    <index></index>
                </v-col>
            </v-row>
        </v-container>
    </company-layout>
</template>

<script>
    import CompanyLayout from "Layouts/Company.vue";
    import Index from 'Components/employees/HolidayPlanner'

    export default {
        components: {
            CompanyLayout,
            Index
        }
    };
</script>
